export function cleanChoiceDescription(description) {
	return description.replace(/^- /, '');
}